// extracted by mini-css-extract-plugin
module.exports = {"copyForm":"CopyText_copyForm__bTKPC","copyButton":"CopyText_copyButton__zgO8t","copyField":"CopyText_copyField__md8a5"};